export const PUSH_NAV_HISTORY = 'MUNDIAL/PUSH_NAV_HISTORY'
export const BACK = 'MUNDIAL/BACK'
export const RESTORE_COMPLETE = 'MUNDIAL/RESTORE_COMPLETE'
export const SET_HEADER_VISIBLE = 'MUNDIAL/SET_HEADER_VISIBLE'

/**
 * Registra el estado de navegación actual antes de cambiar a uno nuevo.
 * @param {{ section: string, activePhase: string|null, activeGroup: string|null }} entry
 */
export function pushNavHistory (entry) {
  return { type: PUSH_NAV_HISTORY, payload: entry }
}

/**
 * Retrocede un nivel: saca la última entrada del history y la coloca
 * en pendingRestore para que el componente correspondiente la aplique.
 */
export function back () {
  return { type: BACK }
}

/**
 * El componente hijo confirma que ya aplicó el restore; limpia pendingRestore.
 */
export function restoreComplete () {
  return { type: RESTORE_COMPLETE }
}

/**
 * Actualiza la visibilidad del BrandHeader.
 * @param {boolean} visible
 */
export function setHeaderVisible (visible) {
  return { type: SET_HEADER_VISIBLE, payload: visible }
}


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/store/actions.js